import React from 'react';
import dompurify from 'dompurify';
import isString from 'lodash/isString';

/**
 * `dangerouslySetInnerHTML` is React's replacement for using `innerHtml` in the browser DOM.
 * It is advised to use cautiously, so we're utilizing `DOMPurify` node package to strengthen
 * the security. For more information, visit http://jira/browse/WEBAPPS-19690.
 */
const TermsContent = ({ termsContent }) => {
	dompurify.addHook('afterSanitizeAttributes', node => {
		// set all elements owning target to target=_blank
		// do not set target attribute for anchor links
		if ('target' in node && node.href.search('#') === -1) {
			node.setAttribute('target', '_blank');
		}
	});

	return (
		<div
			className="common-terms-content"
			data-qa="termscontent"
			{...{ dataqa: 'termscontent' }}
			// eslint-disable-next-line
			dangerouslySetInnerHTML={{
				__html: isString(termsContent) ? dompurify.sanitize(termsContent) : '',
			}}
		/>
	);
};

export default TermsContent;
